import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { OdsV2Service } from "./ods-v2.service";
import {TranslateService} from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { PdfMakeWrapper, Txt, Table, Img, Columns } from 'pdfmake-wrapper';

import { lang_ods } from 'app/idiomas/i18n/ods-v2/ods.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import * as catCampos from "./catalogoCampos";

@Component({
  selector: 'app-ods-v2',
  templateUrl: './ods-v2.component.html',
  styleUrls: ['./ods-v2.component.scss'],
  animations   : fuseAnimations
})
export class OdsV2Component implements OnInit {

  modoEdicion: boolean;
  descargaInfoOk: boolean;
  columnas:any[] = catCampos.CLAVES_COLUMNAS;
  datasets: FormGroup[] = [];
  formValido: boolean;
  arreglosInputs: any = [];
  inputsListos: boolean;

  datosCatalogos: any = { //se inicializa el catalogo de multinacional porque no viene de back
    multinacional: [
      {opcion: 1, texto: 'Si'},
      {opcion: 2, texto: 'No'},
    ]
  };

  institutos: any;
  regiones: any;
  catPaises: any;
  listaPaisesBroker: any;
  sectores: any;
  subSectores: any;

  idEmpresa: string;

  actualiando: boolean;
  institutoEmpresa:any;

  constructor(
    private odsService: OdsV2Service,
    private activatedRoute : ActivatedRoute,
    private translate: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public location: Location
  ) {
    this.activatedRoute.params.subscribe(params => {
      if(params.id){
        this.idEmpresa = params['id'];
        this.modoEdicion = true;
      }
    })

    lang_ods.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit(): void {
    this.creaFormGroups();
    // this.getInstitutos();
    this.getInstitutosVer2();
    // this.getSectorArray();

  }

  getErrorList(errorObject) {
    return errorObject != undefined ? Object.keys(errorObject) : [];
  }

  creaArreglosInputs(){
    this.columnas.forEach(columna => {
      const objetoDataSet = this.arreglosInputs.find(item => item.dataset == columna.dataset);
      if(objetoDataSet == undefined){
        this.arreglosInputs.push({
          dataset: columna.dataset,
          campos: [columna],
          filas: []
        });
      } else{
        objetoDataSet.campos.push(columna);
      }
    });
    this.arreglosInputs.forEach(set => {
      let filaActual = 0;
      let datosFila = [];
      set.campos.forEach(campo => {
        if(campo.fila != filaActual){
          filaActual = campo.fila;
          if(datosFila.length > 0){
            set.filas.push(datosFila);
            datosFila = [];
          }
          datosFila.push(campo);
        } else{
          datosFila.push(campo);
        }
      });
      //hace push del ultimo arreglo de fila creado
      set.filas.push(datosFila);
    });
    console.log("arreglosInputs:",this.arreglosInputs);
    this.inputsListos = true;
  }

  creaFormGroups(){
    let dataSetActual = 0;
    let group = {};
    this.columnas.forEach(columna => {
      if(dataSetActual != columna.dataset){
        if(dataSetActual > 0){
          this.datasets.push(new FormGroup(group) );
        }
        dataSetActual = columna.dataset;
        group = {};
      }
      group[columna.clave] = new FormControl('', [
        Validators.minLength(columna.validaciones.minimos),
        Validators.maxLength(columna.validaciones.maximos),
      ]);

      if(columna.validaciones.obligatorio == true){
        group[columna.clave].addValidators([Validators.required]);
      }

      if(columna.validaciones.bloqueado == true){
        group[columna.clave].disable();
      }

      switch (columna.validaciones.tipo) {
        case 'texto':
          group[columna.clave].addValidators([Validators.pattern(new RegExp("^[a-zA-Z0-9 ÁÉÍÓÚÜáéíóúüñÑ()&.,!#$%=´'|;_}{+-]*$"))]);
        break;
        case 'textoCarac':
          group[columna.clave].addValidators([Validators.pattern(new RegExp("^[a-zA-Z0-9 ÁÉÍÓÚÜáéíóúüñÑ()&.,!#/$%=´'|;_}{+-]*$"))]);
        break;
        case 'anio':
          group[columna.clave].addValidators([Validators.min(1800), Validators.max(new Date().getFullYear()), Validators.pattern(new RegExp("^[0-9]+$"))]);
        break;
        case 'numero':
          group[columna.clave].addValidators([Validators.pattern(new RegExp("^[0-9]+$"))]);
        break;
        case 'email':
          group[columna.clave].addValidators([Validators.email]);
        break;
      }
    });
    //inserta el ultimo formgroup
    this.datasets.push(new FormGroup(group) );
    console.log("formgroups:",this.datasets);

    this.creaArreglosInputs();

    if(this.idEmpresa != undefined){
      this.getDatosEmpresa();
    }

    this.datasets.forEach((dataset,i) => {
      dataset.valueChanges.subscribe( (res) => {
        // console.log("dataset",i,":",dataset.status);
        // console.log("cambioDetectado:",res);


        if(dataset.status == 'VALID'){
          this.formValido = this.formValido && true;
        }
        else{
          this.formValido = this.formValido && false;
        }
      });
    });
  }

  getDatosEmpresa(){
    const controlesBloqueados = ['institutoEmpresa', 'totalColaboradores'];
    const controlesParseInt = ['sector', 'subSector', 'multinacional', 'region']; //DATOS QUE DEBEN TRANSFORMARSE A NUMERO
    this.odsService.getDatosEmpresa(this.idEmpresa).subscribe((respuesta:any) => {
      respuesta.Nommultinacional='';
      console.log("getDatosEmpresa:",respuesta);
      this.institutoEmpresa=respuesta.data.institutoEmpresa;
      this.eligeInstituto(respuesta.data.institutoEmpresa);
      let esperaSectores = setInterval(() => {
        if(this.sectores != undefined){
          this.eligeSector(parseInt(respuesta.data.sector));
          clearInterval(esperaSectores);
        }
      },0);
      if(respuesta.data.multinacional != ''){
        if (respuesta.data.multinacional=="1") {
          this.columnas[15].validaciones.visible=true;
          this.columnas[15].validaciones.obligatorio=true;
        }else{
          this.columnas[15].validaciones.visible=false;
          this.columnas[15].validaciones.obligatorio=false;

        }
      }else{
        this.columnas[15].validaciones.visible=false;
        this.columnas[15].validaciones.obligatorio=false;

      }

      this.datasets.forEach((dataset,i) => {
        for(let k in respuesta.data){
          if(dataset.controls.hasOwnProperty(k)){
            if(controlesParseInt.includes(k)){
              dataset.controls[k].setValue(parseInt(respuesta.data[k]));
            } else{
              dataset.controls[k].setValue(respuesta.data[k]);
            }
            if(!controlesBloqueados.includes(k)){
              dataset.controls[k].enable();
            } else{
              dataset.controls[k].disable();
            }
          }
        }
        //desbloquea resto de campos que hayan quedado bloqueados
        for (let control in dataset.controls) {
          if(!controlesBloqueados.includes(control)){
            if(dataset.controls[control].status == 'DISABLED'){
              dataset.controls[control].enable();
            }
          }
        }
      });
      this.compruebaDescargaPDF();
    });
  }

  compruebaDescargaPDF(){
    let refPM = this.datasets[1];
    let refRH = this.datasets[2];
    let refTI = this.datasets[3];
    if(refPM.controls['emailResponsable'].status == 'VALID' && refRH.controls['emailRH'].status == 'VALID' && refTI.controls['emailTI'].status == 'VALID'){
      this.descargaInfoOk = true;
    }
  }

  getInstitutos(){
    this.odsService.getInstitutos().subscribe((respuesta:any) => {
      console.log("getInstitutos:",respuesta);
      if(respuesta.success){
        const instituto = localStorage.getItem('instituto_id');
        switch (instituto) {
          case '14':  //GCTI
            const datosInst14 = respuesta.Institutos.find(item => item.numInstituto == 14);
            this.institutos = [datosInst14];
          break;
          case '18':  //AMCO
            const datosInst18 = respuesta.Institutos.find(item => item.numInstituto == 18);
            this.institutos = [datosInst18];
          break;
          default:
            this.institutos = respuesta.Institutos;
        }
        this.datosCatalogos['institutoEmpresa'] = this.institutos;
      }
    });
  }

  getInstitutosVer2(){
    this.odsService.getInstitutosV2(localStorage.getItem('levelUser_tmp'),localStorage.getItem('instituto_id')).subscribe((respuesta:any) => {
      console.log("respuesta getInstitutosV2:",respuesta);
      if(respuesta.success){
        const instituto = localStorage.getItem('instituto_id');
        switch (instituto) {
          case '14':  //GCTI
            const datosInst14 = respuesta.institutos.find(item => item.numInstituto == 14);
            this.institutos = [datosInst14];
          break;
          case '18':  //AMCO
            const datosInst18 = respuesta.institutos.find(item => item.numInstituto == 18);
            this.institutos = [datosInst18];
          break;
          default:
            this.institutos = respuesta.institutos;
        }
        this.datosCatalogos['institutoEmpresa'] = this.institutos;
      }
    });
  }

  getSectorArray() {
    this.odsService.getSectorarray().subscribe((respuesta:any) => {
      console.log("getSectores:",respuesta);
      this.sectores = respuesta.Sectores;
      this.datosCatalogos['sector'] = this.sectores;
    }, error => {
      console.log("error", error);
    })
  }

  eligeInstituto(broker:any){
    // console.log("seleccionado:",broker);
    this.getRegiones(broker);
    this.getCatalogos(broker, this.translate.currentLang);
    this.getPaisesBroker(broker.toString());
    this.getSectoresVersion2(broker, this.translate.currentLang);
  }
  getRegiones(broker:any){
    let datos = { institutoId: broker };
    this.odsService.getRegiones(datos).subscribe((respuesta:any) => {
      console.log("getRegiones:",respuesta);
      this.regiones = respuesta.regiones;
      this.datosCatalogos['region'] = this.regiones;
    }, error => {
      console.log("error", error);
    })
  }
  getCatalogos(instituto:any, idioma:any){
    this.odsService.getCatPaises(instituto, idioma).subscribe((respuesta:any) => {
      console.log("getCatalogos:",respuesta);
      this.catPaises = respuesta.jsonConfig.country;
      this.datosCatalogos['pais'] = this.catPaises;
      // this.validacionPais=true;
    });
  }
  getPaisesBroker(broker:string){
    this.listaPaisesBroker = undefined;
    this.odsService.getPaisesBroker(broker).subscribe((respuesta:any) => {
      console.log("getPaisesBroker:",respuesta);
      if(respuesta.success){
        respuesta.result.forEach(pais => { pais.CountryName = pais.CountryName.trim() });
        this.listaPaisesBroker = respuesta.result;
        this.datosCatalogos['country_application'] = this.listaPaisesBroker;
      }
    });
  }

  calculaTotalColabs(valor:any){
    let refDataset = this.datasets[0];  //primer dataset, donde estan los totales de colaboradores
    console.log('refDataset',refDataset);
    let empleadosCompleto = refDataset.controls['empleadosCompleto'].value.length > 0 ? parseInt(refDataset.controls['empleadosCompleto'].value) : 0;
    let empleadosParcial = refDataset.controls['empleadosParcial'].value.length > 0 ? parseInt(refDataset.controls['empleadosParcial'].value) : 0;
    refDataset.controls['totalColaboradores'].setValue(empleadosCompleto + empleadosParcial);
    this.actualizaDatos('totalColaboradores', refDataset);
  }

  eligeSector(sector:any){
    // var coincidentes:any = this.sectores.filter(function(item) { return item.SectorID === sector; });
    // console.log("coincidentes:",coincidentes);
    // this.subSectores = coincidentes[0].subSectores;
    // this.datosCatalogos['subSector'] = this.subSectores;
    let instituto = this.institutoEmpresa == undefined? this.datasets[0].controls['institutoEmpresa'].value : this.institutoEmpresa;
    this.odsService.getSubSectoresV2(instituto,this.translate.currentLang,sector).subscribe((respuesta:any) => {
      console.log("getSubSectoresV2:",respuesta);
      this.datosCatalogos['subSector'] = respuesta.result;
      // this.datosCatalogos['sector'] = this.sectores;
    });
  }

  mostrarNomMul(multinacional:any){
    console.log('multinacional',multinacional);
    if (multinacional=="1") {
      this.columnas[15].validaciones.visible=true;
      this.columnas[15].validaciones.obligatorio=true;
    }else{
      this.columnas[15].validaciones.visible=false;
      this.columnas[15].validaciones.obligatorio=false;
      console.log('this.columnas',this.columnas);

    }
  }

  actualizaDatos(clave:string, datosFormulario:any){
    console.log("formulario:",datosFormulario);
    console.log("claveActualizar:",clave);
    const clavesExentas = ['institutoEmpresa'];
    const clavesRegistroInicial = ['nombreEmpresa', 'shortName', 'country_application'];
    const valorValido = (claveInicial) => datosFormulario.controls[claveInicial].status == 'VALID';

    // if (clave=='totalColaboradores') {
    //   const valorValido = (claveInicial) => datosFormulario.controls[claveInicial].status == 'DISABLED';
    // }else{
    //   const valorValido = (claveInicial) => datosFormulario.controls[claveInicial].status == 'VALID';
    // }

    if(!clavesExentas.includes(clave)){
      if(!this.idEmpresa){  //si no hay id empresa se crea la empresa
        if(clavesExentas.every(valorValido) && clavesRegistroInicial.every(valorValido)){
          // console.log("formulario minimo listo");
          this.actualiando = true;
          const datosRegistro = {
            institutoEmpresa: datosFormulario.controls['institutoEmpresa'].value,
            country_application: datosFormulario.controls['country_application'].value.trim(),
            nombreEmpresa: datosFormulario.controls['nombreEmpresa'].value.trim(),
            shortName: datosFormulario.controls['shortName'].value.trim(),
          };
          this.odsService.registraEmpresa(datosRegistro).subscribe((respuesta:any) => {
            console.log("registraEmpresa:",respuesta);
            this.actualiando = false;
            if(respuesta.message == "Success: Number of documents inserted: 1"){
              //despues de guardar la empresa, desbloquea los demas campos y bloquea los de instituto y pais sede
              this.datasets.forEach((dataset,i) => {
                for (let control in dataset.controls) {
                  if(clavesExentas.includes(control)){
                    dataset.controls[control].disable();
                  } else{
                    if(control != "totalColaboradores"){  //este control no se debe habilitar, se calcula automaticamente
                      dataset.controls[control].enable();
                    }
                  }
                }
              });
              this.idEmpresa = respuesta.data._id;
            } else{
              if(respuesta.message == "empresa_saveEmpresa3_1"){
                this.mensajeSwal(this.translate.instant('ODS.MODALES.EMPRESA_EXISTE'), 2);
              } else{
                this.mensajeSwal(this.translate.instant('ODS.MODALES.ERROR_GUARDADO'), 2);
              }
            }
          });
        } else{
          console.log("formulario minimo no listo");
        }
      } else{ //si ya hay id empresa se actualiza el dato indicado
        // console.log('clave a modificar',clave);
      if (clave=='totalColaboradores') {
        // console.log('entro a modificar =====',clave);
        this.actualiando = true;
        let datoActualizado:any = {};
        datoActualizado[clave] = typeof datosFormulario.controls[clave].value === 'string' ? datosFormulario.controls[clave].value.trim() : datosFormulario.controls[clave].value;
        this.odsService.actualizaEmpresa(this.idEmpresa, datoActualizado).subscribe((respuesta:any) => {
          console.log("actualizaEmpresa:",respuesta);

          this.actualiando = false;
        });
      }else{
        if(valorValido(clave)){
          // console.log('entro a modificar +++++++',clave);
          this.actualiando = true;
          let datoActualizado:any = {};
          datoActualizado[clave] = typeof datosFormulario.controls[clave].value === 'string' ? datosFormulario.controls[clave].value.trim() : datosFormulario.controls[clave].value;
          this.odsService.actualizaEmpresa(this.idEmpresa, datoActualizado).subscribe((respuesta:any) => {
            console.log("actualizaEmpresa:",respuesta);
            this.actualiando = false;
          });
        } else{
          console.log("el dato no es valido");
        }
      }

      }
    }
  }

  mensajeSwal(texto:string, tipo:number){
    Swal.fire({
      icon: tipo == 1 ? 'success' : 'error',
      title: texto,
      confirmButtonText: this.translate.instant('ODS.BOTONES.ACEPTAR')
    });
  }

  async generatePDF(){
    const pdf = new PdfMakeWrapper();
    const fechaDescarga = new Date();
    console.log('this.dataset[0]',this.datasets[0]);
    console.log('this.datosCatalogos',this.datosCatalogos['sector']);

    const refDatosForm = this.datasets[0];
    const refDatosPM = this.datasets[1];
    const refDatosRH = this.datasets[2];
    const refDatosTI = this.datasets[3];

    Swal.fire({
      title: this.translate.instant('ODS.MODALES.GENERANDO_PDF'),
      allowOutsideClick: false,
      showConfirmButton: false,
      imageUrl: localStorage.getItem('urlGifBroker'),
      imageWidth: 100
    });

    const varLang = 'ODS.CAMPOS';

    let empresa = this.translate.instant(`${varLang}.nombreEmpresa`);
    let empresaNombreCorto = this.translate.instant(`${varLang}.shortName`);
    let nombrePublicacion = this.translate.instant(`${varLang}.nombrePublicacion`);
    let idSalesForce = this.translate.instant(`${varLang}.idSalesForce`);
    let codigoProyecto = this.translate.instant(`${varLang}.codigoProyecto`);
    let anioFundacion = this.translate.instant(`${varLang}.anioFundacion`);
    let empleadosCompleto = this.translate.instant(`${varLang}.empleadosCompleto`);
    let empleadosParcial = this.translate.instant(`${varLang}.empleadosParcial`);
    let emepleadosTotal = this.translate.instant(`${varLang}.totalColaboradores`);
    let sector = this.translate.instant(`${varLang}.PDF_sector`);
    let subsector = this.translate.instant(`${varLang}.PDF_subSector`);
    let multinacional = this.translate.instant(`${varLang}.multinacional`);
    let region = this.translate.instant(`${varLang}.PDF_region`);

    let nombre = this.translate.instant(`${varLang}.nombreResponsable`);
    let apellido = this.translate.instant(`${varLang}.apellidoResponsable`);
    let nombreCompleto = this.translate.instant(`${varLang}.nombreRH`);
    let email = this.translate.instant(`${varLang}.emailResponsable`);
    let tel = this.translate.instant(`${varLang}.telResponsable`);
    let ext = this.translate.instant(`${varLang}.extResponsable`);
    let celular = this.translate.instant(`${varLang}.celResponsable`);

    let informacionEmpresa = this.translate.instant('ODS.FORMULARIOS.0');
    let informacionEmpresaTitulo = this.translate.instant('ODS.FORMULARIOS.0');
    let responsableP = this.translate.instant('ODS.FORMULARIOS.1');
    let directorRH = this.translate.instant('ODS.FORMULARIOS.2');
    let responsableTI = this.translate.instant('ODS.FORMULARIOS.3');

    let fecha = this.translate.instant(`${varLang}.PDF_fecha`);
    let hora = this.translate.instant(`${varLang}.PDF_hora`);

    let sectorID: any;
    if (refDatosForm.controls['sector'].value!="") {
      let indiceIdSector=  this.datosCatalogos['sector'].findIndex(item => item.SectorID ==  refDatosForm.controls['sector'].value);
      if (indiceIdSector!=-1) {
        sectorID = this.datosCatalogos['sector'][indiceIdSector].SectorText;
      }else{
        sectorID = '';
      }

    }

    let subSectorID :any;
    if (refDatosForm.controls['subSector'].value!="") {
      let indiceSubSectorID=    this.datosCatalogos['subSector'].findIndex(item => item.SubsectorID ==  refDatosForm.controls['subSector'].value);
      if (indiceSubSectorID!=-1) {
        subSectorID =   this.datosCatalogos['subSector'][indiceSubSectorID].SubsectorText;
      }else{
        subSectorID = '';
      }

    }

    let multinacionalID = "";

    switch (refDatosForm.controls['multinacional'].value) {
      case 1:
        multinacionalID = this.translate.instant('ODS.CATALOGOS.multinacional.1');
      break;
      case 2:
        multinacionalID = this.translate.instant('ODS.CATALOGOS.multinacional.2');
      break;
    }

    let regionID = this.translate.instant('ODS.CATALOGOS.region.'+refDatosForm.controls['region'].value);

    let nombrePublicacionIngresada = refDatosForm.controls['nombrePublicacion'].status == 'VALID' ? refDatosForm.controls['nombrePublicacion'].value : "";
    let idSalesFroceIngresado = refDatosForm.controls['idSalesForce'].status == 'VALID' ? refDatosForm.controls['idSalesForce'].value : "";
    let codigoProyectoIngresado = refDatosForm.controls['codigoProyecto'].status == 'VALID' ? refDatosForm.controls['codigoProyecto'].value : "";
    let anioFundacionIngresado = refDatosForm.controls['anioFundacion'].status == 'VALID' ? refDatosForm.controls['anioFundacion'].value : "";
    let empleadosCompletoIngresado = refDatosForm.controls['empleadosCompleto'].status == 'VALID' ? refDatosForm.controls['empleadosCompleto'].value : "";
    let empleadosParcialIngresado = refDatosForm.controls['empleadosParcial'].status == 'VALID' ? refDatosForm.controls['empleadosParcial'].value : "";

    if(isNaN(refDatosForm.controls['sector'].value)){
      sectorID="";
    }

    if(isNaN(refDatosForm.controls['subSector'].value)){
      subSectorID="";
    }

    if(isNaN(refDatosForm.controls['region'].value)){
      regionID="";
    }

    let nombreRPIngresado = refDatosPM.controls['nombreResponsable'].status == 'VALID' ? refDatosPM.controls['nombreResponsable'].value : "";
    let apellidoRPIngresado = refDatosPM.controls['apellidoResponsable'].status == 'VALID' ? refDatosPM.controls['apellidoResponsable'].value : "";
    let telRPIngresado = refDatosPM.controls['telResponsable'].status == 'VALID' ? refDatosPM.controls['telResponsable'].value : "";
    let extRPIngresado = refDatosPM.controls['extResponsable'].status == 'VALID' ? refDatosPM.controls['extResponsable'].value : "";
    let celRPIngresado = refDatosPM.controls['celResponsable'].status == 'VALID' ? refDatosPM.controls['celResponsable'].value : "";

    let nombreRHIngresado = refDatosRH.controls['nombreRH'].status == 'VALID' ? refDatosRH.controls['nombreRH'].value : "";
    let telRHIngresado = refDatosRH.controls['telRH'].status == 'VALID' ? refDatosRH.controls['telRH'].value : "";
    let extRHIngresado = refDatosRH.controls['extRH'].status == 'VALID' ? refDatosRH.controls['extRH'].value : "";
    let celRHIngresado = refDatosRH.controls['celRH'].status == 'VALID' ? refDatosRH.controls['celRH'].value : "";

    let nombreTIIngresado = refDatosTI.controls['nombreTI'].status == 'VALID' ? refDatosTI.controls['nombreTI'].value : "";
    let telTIIngresado = refDatosTI.controls['telTI'].status == 'VALID' ? refDatosTI.controls['telTI'].value : "";
    let extTIIngresado = refDatosTI.controls['extTI'].status == 'VALID' ? refDatosTI.controls['extTI'].value : "";
    let celTIIngresado = refDatosTI.controls['celTI'].status == 'VALID' ? refDatosTI.controls['celTI'].value : "";

    pdf.info({
      title: refDatosForm.controls['nombreEmpresa'].value,
      author: 'CULTURAL GO®',
      subject: 'Informativo'
    });

    pdf.images({
      logo1:await new Img('./assets/gptw.jpg').width(100).height(100).build(),
      logo2:await new Img('./assets/cgo.png').width(104).height(53).build()
    });

    pdf.add(
      new Columns([
        await new Img('logo1', true).width(60).height(60).build(),
        new Txt(informacionEmpresaTitulo).bold().alignment('center').fontSize(20).end,
        await new Img('logo2', true).width(89).height(46).build()
      ]).end
    );

    pdf.add(pdf.ln(1));
    pdf.add(new Txt(fecha + fechaDescarga.toLocaleDateString()).bold().end);
    pdf.add(new Txt(hora + fechaDescarga.toLocaleTimeString()).bold().end);

    //SALTO DE LINEA
    pdf.add(pdf.ln(1));

    //TABLA INFORMACION DE EMPRESA
    pdf.add(
      new Table([
        [ empresa, refDatosForm.controls['nombreEmpresa'].value],
        [ empresaNombreCorto, refDatosForm.controls['shortName'].value],
        [ nombrePublicacion, nombrePublicacionIngresada],
        [ idSalesForce, idSalesFroceIngresado],
        [ codigoProyecto, codigoProyectoIngresado],
        [ anioFundacion, anioFundacionIngresado],
        [ empleadosCompleto, empleadosCompletoIngresado],
        [ empleadosParcial, empleadosParcialIngresado],
        [ emepleadosTotal, refDatosForm.controls['totalColaboradores'].value],
        [ sector, sectorID],
        [ subsector, subSectorID],
        [ multinacional, multinacionalID],
        [ region, regionID]
      ]).widths([ 150, '*' ]).end
    );

    pdf.add(pdf.ln(2));
    pdf.add(new Txt(responsableP).bold().end);
    pdf.add(pdf.ln(1));

    //TABLA RP
    pdf.add(
      new Table([
        [ nombre, nombreRPIngresado],
        [ apellido, apellidoRPIngresado],
        [ email, refDatosPM.controls['emailResponsable'].value],
        [ tel, telRPIngresado],
        [ ext, extRPIngresado],
        [ celular, celRPIngresado]
      ]).widths([ 150, '*' ]).end
    );

    pdf.add(pdf.ln(2));
    pdf.add(new Txt(directorRH).bold().end);
    pdf.add(pdf.ln(1));

    //TABLA DRH
    pdf.add(
      new Table([
        [ nombreCompleto, nombreRHIngresado],
        [ email, refDatosRH.controls['emailRH'].value],
        [ tel, telRHIngresado],
        [ ext, extRHIngresado],
        [ celular, celRHIngresado]
      ]).widths([ 150, '*' ]).end
    );

    pdf.add(pdf.ln(2));
    pdf.add(new Txt(responsableTI).bold().end);
    pdf.add(pdf.ln(1));

    //TABLA RTI
    pdf.add(
      new Table([
        [ nombreCompleto, nombreTIIngresado],
        [ email, refDatosTI.controls['emailTI'].value],
        [ tel, telTIIngresado],
        [ ext, extTIIngresado],
        [ celular, celTIIngresado]
      ]).widths([ 150, '*' ]).end
    );

    pdf.create().download(informacionEmpresa + refDatosForm.controls['nombreEmpresa'].value + ".pdf");
    Swal.close();
  }

  getSectoresVersion2(boker,lang){
    this.odsService.getSectoresV2(boker,lang).subscribe((respuesta:any) => {
      console.log("getSectoresV2:",respuesta);
      this.sectores = respuesta.result;
this.datosCatalogos['sector'] = this.sectores;

    });
  }

  getSubSectoresVersion2(){
    this.odsService.getSubSectoresV2(1,'es',1).subscribe((respuesta:any) => {
      console.log("getSubSectoresV2:",respuesta);
      // this.datosCatalogos['sector'] = this.sectores;
    });
  }

}
